// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"5924f9a7","453":"9bf0fb47","779":"2bbc0b4f"}[chunkId] + ".chunk.js";
};